import React, { useEffect, useRef } from 'react';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { getWMSFields } from '../../../utils/commonAPICalls';
import { useAuth } from '../../context/wms-context';
import SFDynamicForm from '../sf-dynamic-form/Index.js';
import logError from '../../../utils/errorUtil';

export default function NewLineFormWrapper({
    status,
    setStatus,
    formData,
    setFormData,
    selectedManifest,
    selectedMultipleManifest = null,
    setNewPartDefaultName,
}) {
    const { currentUser } = useAuth();
    const didFetchRef = useRef(false);

    useEffect(() => {
        const isMultiple = selectedManifest?.Id === 'multiple';
        const effectiveManifest = isMultiple ? selectedMultipleManifest : selectedManifest;

        if (!effectiveManifest?.Id || didFetchRef.current) return;

        didFetchRef.current = true;

        let cancelled = false;

        setStatus((s) => ({ ...s, loading: true }));

        const payload = {
            manifest: { ...effectiveManifest },
            authentication: {
                userId: currentUser.authentication.userId,
                userEmail: currentUser.authentication.userEmail,
                userCompany: currentUser.authentication.userCompany || localStorage.getItem('company'),
            },
            tableStructure: currentUser.tableStructures,
        };

        getWMSFields(payload, 'get-manifest-line-fields', 'get-manifest-line-dropdowns')
            .then((data) => {
                if (cancelled) return;

                const warehouseData = data.find((object) => {
                    return object.name == 'inscor__Warehouse__c';
                });
                const mainWarehouse = warehouseData.dropdownData.find((location) => {
                    return location.Name == 'Main Warehouse';
                });

                const newFormData = data.map((object) => {
                    if (object.name == 'inscor__Warehouse__c') {
                        return { ...object, valueName: mainWarehouse.Name || '', value: mainWarehouse.Id || '' };
                    } else return object;
                });

                setFormData(newFormData);
                setStatus((s) => ({ ...s, loading: false }));
            })
            .catch((error) => {
                if (cancelled) return;
                logError(error, 'NewLineFormWrapper');
                setStatus((s) => ({ ...s, loading: false, error: true }));
            });

        // Cleanup
        return () => {
            cancelled = true;
        };
    }, [selectedManifest?.Id, selectedMultipleManifest?.Id, currentUser]);

    if (status.loading) return <LoadingSpinner />;
    return (
        <div className='grid grid-cols-1 gap-4 p-2'>
            <SFDynamicForm
                formData={formData}
                setFormData={setFormData}
                cols={1}
                includeAddRowButton={true}
                setNewPartDefaultName={setNewPartDefaultName}
            />
        </div>
    );
}
